import { jsx as _jsx } from "react/jsx-runtime";
import { createPolymorphicComponent, Skeleton as MantineSkeleton } from '@mantine/core';
const _Skeleton = (props) => {
    return _jsx(MantineSkeleton, { ...props });
};
export const Skeleton = createPolymorphicComponent(_Skeleton);
